<div class="home" data-testid="decim-home-container">
  <div class="top">
    <div class="top-left">
      <img src="https://oes-hosted-images-public.s3.amazonaws.com/agree/drc-flag.webp" height="109px" />
      <h2>Plateforme numérique nationale</h2>
      <p>Programme d'expansion de l'accès à l'électricité en s'appuyant sur le secteur privé</p>
      <button [routerLink]="['../finance/programs']" class="btn btn-primary">Appliquer</button>
    </div>
    <div class="top-right">
      <div class="sun-solar">
        <img src="https://oes-hosted-images-public.s3.amazonaws.com/agree-panels.png" />
      </div>
    </div>
  </div>

  <div class="middle">
    <h3>En se concentrant sur les systèmes solaires domestiques, les mini-réseaux et la cuisson propre.</h3>
  </div>

  <div class="bottom">
    <h2>En collaboration avec:</h2>
    <div class="bottom-logo-box">
      <div class="bottom-logos">
        <img src="https://oes-hosted-images-public.s3.amazonaws.com/la-banque-mondiale-logo.png" width="370px" />
      </div>
    </div>
  </div>
  <div class="bottom">
    <div class="bottom-logo-box">
      <div class="bottom-logos">
        <img src="https://oes-hosted-images-public.s3.amazonaws.com/agree/drc-gov.webp" width="343px" />
      </div>
    </div>
    <div class="bottom-logo-box">
      <div class="bottom-logos">
        <img src="https://oes-hosted-images-public.s3.amazonaws.com/agree/are-logo.webp" width="157px" />
      </div>
    </div>
    <div class="bottom-logo-box">
      <div class="bottom-logos">
        <img src="https://oes-hosted-images-public.s3.amazonaws.com/agree/anser-logo.webp" width="208px" />
      </div>
    </div>
    <div class="bottom-logo-box">
      <div class="bottom-logos">
        <img src="https://oes-hosted-images-public.s3.amazonaws.com/agree/ucm-logo.webp" width="192px" />
      </div>
    </div>
  </div>
</div>
